import { render, staticRenderFns } from "./printWKPurchases.vue?vue&type=template&id=067f1594&scoped=true&"
import script from "./printWKPurchases.vue?vue&type=script&lang=js&"
export * from "./printWKPurchases.vue?vue&type=script&lang=js&"
import style0 from "./printWKPurchases.vue?vue&type=style&index=0&id=067f1594&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067f1594",
  null
  
)

component.options.__file = "printWKPurchases.vue"
export default component.exports